import { render, staticRenderFns } from "./micoapp_basicinfo.vue?vue&type=template&id=d27490c0&scoped=true"
import script from "./micoapp_basicinfo.vue?vue&type=script&lang=js"
export * from "./micoapp_basicinfo.vue?vue&type=script&lang=js"
import style0 from "./micoapp_basicinfo.vue?vue&type=style&index=0&id=d27490c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27490c0",
  null
  
)

export default component.exports